export const actionTypes = {
    GET_ITEMS: 'items/getItems',
    ADD_ITEM: 'items/addItem',
    DELETE_ITEM: 'items/deleteItem',
    SORT_ITEM: 'items/sortItem'
  };
  